var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCouriosity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 67,
    viewBox: "0 0 71 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8194 28.525C46.8639 27.0988 48.5243 25.1895 49.6531 22.9669C50.7818 20.7443 51.3439 18.2772 51.2894 15.785C51.1527 11.819 49.4694 8.06397 46.5996 5.32317C43.7299 2.58237 39.9014 1.07344 35.9334 1.11917C31.9653 1.1649 28.1727 2.76166 25.3668 5.56787C22.5609 8.37408 20.9646 12.1669 20.9194 16.135C20.9597 20.7649 22.8373 25.1893 26.1394 28.435C26.8506 29.1075 27.3673 29.9595 27.6348 30.901C27.9023 31.8426 27.9108 32.839 27.6594 33.785L20.8594 62.125C20.7186 62.664 20.7034 63.2281 20.8149 63.7739C20.9265 64.3197 21.1619 64.8326 21.5029 65.2732C21.8439 65.7137 22.2815 66.0701 22.7819 66.3148C23.2824 66.5596 23.8323 66.6862 24.3894 66.685H45.0194C45.571 66.685 46.1155 66.5601 46.6119 66.3194C47.1083 66.0788 47.5437 65.7288 47.8854 65.2956C48.2271 64.8625 48.4661 64.3576 48.5846 63.8189C48.7031 63.2801 48.6979 62.7215 48.5694 62.185L42.5694 34.305C42.3166 33.227 42.3963 32.0978 42.798 31.066C43.1996 30.0342 43.9044 29.1483 44.8194 28.525Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3597 50.7751C44.8259 50.7751 52.4997 43.1013 52.4997 33.6351C52.4997 24.169 44.8259 16.4951 35.3597 16.4951C25.8936 16.4951 18.2197 24.169 18.2197 33.6351C18.2197 43.1013 25.8936 50.7751 35.3597 50.7751Z",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 51.3852C58.5095 51.3852 69.8495 37.1352 69.9995 37.0852C67.6195 33.0852 57.8795 16.1352 35.2095 16.1852C12.7495 16.2352 2.09953 32.8652 1.01953 35.4352C1.01953 35.4352 9.01953 51.3752 35.5095 51.3852Z",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.98,
    height: 65.75,
    fill: "white",
    transform: "translate(0.0195312 0.915039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCouriosity);
export default __webpack_public_path__ + "static/media/icon-couriosity.ea22c53ebfef2b7e843d43e9864d4d4c.svg";
export { ForwardRef as ReactComponent };